import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Prvi teden",
  "description": "",
  "published": "2007-10-07T00:00:00.000Z",
  "redirect_from": ["/blog/prvi-teden/swizec/147"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pa smo tam, prvega tedna študentskega Å¾ivljenja je prav zares konec in takoj lahko vidim, da se bo treba na marsikaj navadit in marsikaj popolnoma pozabit. Pouk ni veÄ obvezen in ne dogaja se veÄ v striktnem delu dneva ampak je postavljen v najbolj nadleÅ¾en Äas. Ponavadi lepo nekam na sredo tako da ne prej ne potem ne moreš kaj veliko doseÄi in postoriti.`}</p>
    <p>{`Organizirati dovolj dela na teden in hoditi na veÄino predavanj bo terjalo kar nekaj Å¾ongliranja dokler ne najdem pravem rešitve in ureditve dneva. Sploh Äe pomislimo, da moram vsak dan še poskrbeti, da ostanem zdrav in v formi. Na sreÄo je noÄ dovolj dolga, da priskrbi Äas za delo na šolskih stvareh in osebnih projektih. Vsaj to.`}</p>
    <p>{`Pred nekaj dnevi, v Äetrtek, Äe se ne motim, je v moj poštni nabiralnik prispela moja lastna zastonj kopija `}<a parentName="p" {...{
        "href": "http://steampunkmagazine.com/"
      }}>{`Steampunk Magazine`}</a>{` in moram reÄi, da je prav poseben obÄutek prviÄ v Å¾ivljenju dobiti zastonj revijo, ker vsebuje tvoje pisanje. Na Å¾alost je še nisem imel Äasa prebrati, tako da o njej ne morem povedati veliko, ampak Äe sklepamo po prejšnjih številkah je prav odliÄna. Se pa zdi, da se iz številke v številko redi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      